export function getProjectRevenueReportEndpoint(projectId: string) {
	return `reports/project-revenue/${projectId}`;
}
